export interface RouteHydrationStateLike {
  attempted: boolean;
  succeeded: boolean;
  explicitTextOnly: boolean;
}

export function shouldSkipHydrationForOwnedArtifact(args: {
  sameRoute: boolean;
  hasOwnedArtifact: boolean;
  routeState: RouteHydrationStateLike | null;
}): boolean {
  return Boolean(args.sameRoute && args.hasOwnedArtifact && args.routeState?.succeeded);
}

export function shouldSkipHydrationForExplicitTextOnly(args: {
  sameRoute: boolean;
  hasOwnedArtifact: boolean;
  messageCount: number;
  routeState: RouteHydrationStateLike | null;
}): boolean {
  return Boolean(
    args.sameRoute
    && !args.hasOwnedArtifact
    && args.messageCount > 0
    && args.routeState?.succeeded
    && args.routeState.explicitTextOnly,
  );
}

export function deriveExplicitTextOnly(args: {
  hasWorkspaceArtifact: boolean;
  looksLikeOrphanDraftShell: boolean;
  documentsCount: number;
  hasPendingDraft: boolean;
  draftStatus: 'idle' | 'pending' | 'streaming' | 'complete' | 'failed';
  hasChat: boolean;
}): boolean {
  return (
    !args.hasWorkspaceArtifact
    && !args.looksLikeOrphanDraftShell
    && args.documentsCount === 0
    && !args.hasPendingDraft
    && args.draftStatus === 'idle'
    && args.hasChat
  );
}
